module.exports = __webpack_public_path__ + "img/pintecAmount.58b6da63.png";